<template>
  <div class="header__user">
    <div
      @click="toggleDisplayMenu"
      :class="{ 'add-cursor-pointer': !isLaunchDevicePage }"
      class="user-detail gap-2"
    >
      <div class="user-detail__photo">
        <div class="w-[34px]">
          <!-- <img
              class="w-full rounded-full"
              src="data:image/png;base64,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"
              alt="mlive-avatar"
            /> -->
          <div class="user-detail__photo-text">{{ initials }}</div>
        </div>
        <span v-if="joinedUser" class="user-detail__name-text">{{
          joinedUser.fullName
        }}</span>
        <span v-else class="user-detail__name-text">{{ guestName }}</span>
      </div>
      <div class="arrows" v-if="!isLaunchDevicePage">
        <svg
          v-if="userMenu"
          class="rotate-180"
          width="16"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.38184 6L8.38184 10L12.3818 6"
            stroke="#0C0407"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <svg
          v-else
          width="16"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.38184 6L8.38184 10L12.3818 6"
            stroke="#0C0407"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div
      v-if="userMenu && !isLaunchDevicePage"
      class="user-menu"
      v-click-outside="closePopup"
    >
      <ul class="p-4">
        <li>
          <router-link :to="{ path: '/my-profile' }" class="user-menu-item">
            <img
              src="@/assets/images/profile.svg"
              class="user-menu__logo"
              alt="profile"
            />
            <span>{{ $t("navigation.user.profile") }}</span>
          </router-link>
        </li>
        <li
          v-if="!userPlanDetail.isTrial || userPlanDetail.isTransactionRequired"
        >
          <div
            @click="showOrCloseContactSalesMethod()"
            class="flex gap-4 pt-3 pb-3 h-[44px] cursor-pointer user-menu-item"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4.99988 21.87C4.25988 21.87 3.52988 21.59 2.96988 21.03C2.42988 20.49 2.12988 19.77 2.12988 19C2.12988 18.23 2.42988 17.51 2.96988 16.97L15.9699 3.97C17.0899 2.85 18.9099 2.85 20.0299 3.97C20.5699 4.51 20.8699 5.23 20.8699 6C20.8699 6.77 20.5699 7.49 20.0299 8.03L7.02988 21.03C6.46988 21.59 5.73988 21.87 4.99988 21.87ZM17.9999 4.63001C17.6499 4.63001 17.2999 4.76001 17.0299 5.03001L4.02988 18.03C3.76988 18.29 3.62988 18.63 3.62988 19C3.62988 19.37 3.76988 19.71 4.02988 19.97C4.55988 20.5 5.43988 20.5 5.96988 19.97L18.9699 6.97C19.2299 6.71 19.3699 6.37 19.3699 6C19.3699 5.63 19.2299 5.29001 18.9699 5.03001C18.6999 4.76001 18.3499 4.63001 17.9999 4.63001Z"
                fill="#848FAC"
              />
              <path
                d="M18.01 9.73999C17.82 9.73999 17.63 9.66999 17.48 9.51999L14.48 6.51999C14.19 6.22999 14.19 5.74999 14.48 5.45999C14.77 5.16999 15.25 5.16999 15.54 5.45999L18.54 8.45999C18.83 8.74999 18.83 9.22999 18.54 9.51999C18.39 9.66999 18.2 9.73999 18.01 9.73999Z"
                fill="#848FAC"
              />
              <path
                d="M10.0001 5.50001C9.95005 5.50001 9.91005 5.49001 9.86005 5.48001L8.50005 5.08001L7.14005 5.48001C6.96005 5.53001 6.77005 5.48001 6.65005 5.35001C6.52005 5.22001 6.47005 5.04001 6.52005 4.86001L6.92005 3.50001L6.52005 2.14001C6.47005 1.96001 6.52005 1.77001 6.65005 1.65001C6.78005 1.52001 6.97005 1.47001 7.14005 1.52001L8.50005 1.92001L9.86005 1.52001C10.0401 1.47001 10.2201 1.52001 10.3501 1.65001C10.4801 1.78001 10.5301 1.97001 10.4801 2.14001L10.0801 3.50001L10.4801 4.86001C10.5301 5.04001 10.4801 5.23001 10.3501 5.35001C10.2601 5.45001 10.1301 5.50001 10.0001 5.50001ZM8.50005 4.06001C8.55005 4.06001 8.59005 4.07001 8.64005 4.08001L9.26005 4.26001L9.08005 3.64001C9.05005 3.55001 9.05005 3.45001 9.08005 3.36001L9.26005 2.74001L8.64005 2.92001C8.55005 2.95001 8.45005 2.95001 8.36005 2.92001L7.74005 2.74001L7.92005 3.36001C7.95005 3.45001 7.95005 3.55001 7.92005 3.64001L7.74005 4.26001L8.36005 4.08001C8.41005 4.07001 8.45005 4.06001 8.50005 4.06001Z"
                fill="#848FAC"
              />
              <path
                d="M6.00005 11.5C5.95005 11.5 5.91005 11.49 5.86005 11.48L4.50005 11.08L3.14005 11.48C2.96005 11.53 2.78005 11.48 2.65005 11.35C2.52005 11.22 2.47005 11.03 2.52005 10.86L2.92005 9.50001L2.52005 8.14001C2.47005 7.96001 2.52005 7.77001 2.65005 7.65001C2.78005 7.53001 2.97005 7.47001 3.14005 7.52001L4.50005 7.92001L5.86005 7.52001C6.03005 7.47001 6.22005 7.52001 6.35005 7.65001C6.48005 7.78001 6.53005 7.97001 6.48005 8.14001L6.08005 9.50001L6.48005 10.86C6.53005 11.04 6.48005 11.23 6.35005 11.35C6.26005 11.45 6.13005 11.5 6.00005 11.5ZM4.50005 10.06C4.55005 10.06 4.59005 10.07 4.64005 10.08L5.26005 10.26L5.08005 9.64001C5.05005 9.55001 5.05005 9.45001 5.08005 9.36001L5.26005 8.74001L4.64005 8.92001C4.55005 8.95001 4.45005 8.95001 4.36005 8.92001L3.74005 8.74001L3.92005 9.36001C3.95005 9.45001 3.95005 9.55001 3.92005 9.64001L3.74005 10.26L4.36005 10.08C4.41005 10.07 4.45005 10.06 4.50005 10.06Z"
                fill="#848FAC"
              />
              <path
                d="M21.0001 16.5C20.9501 16.5 20.9101 16.49 20.8601 16.48L19.5001 16.08L18.1401 16.48C17.9601 16.53 17.7801 16.48 17.6501 16.35C17.5201 16.22 17.4701 16.03 17.5201 15.86L17.9201 14.5L17.5201 13.14C17.4701 12.96 17.5201 12.77 17.6501 12.65C17.7801 12.53 17.9701 12.47 18.1401 12.52L19.5001 12.92L20.8601 12.52C21.0301 12.47 21.2201 12.52 21.3501 12.65C21.4801 12.78 21.5301 12.97 21.4801 13.14L21.0801 14.5L21.4801 15.86C21.5301 16.04 21.4801 16.23 21.3501 16.35C21.2601 16.45 21.1301 16.5 21.0001 16.5ZM19.5001 15.06C19.5501 15.06 19.5901 15.07 19.6401 15.08L20.2601 15.26L20.0801 14.64C20.0501 14.55 20.0501 14.45 20.0801 14.36L20.2601 13.74L19.6401 13.92C19.5501 13.95 19.4501 13.95 19.3601 13.92L18.7401 13.74L18.9201 14.36C18.9501 14.45 18.9501 14.55 18.9201 14.64L18.7401 15.26L19.3601 15.08C19.4101 15.07 19.4501 15.06 19.5001 15.06Z"
                fill="#848FAC"
              />
            </svg>
            <span class="font-bold">{{
              $t("navigation.user.subscriptiondetails")
            }}</span>
          </div>
        </li>
        <!-- <li>
          <router-link :to="{ path: '/pricing' }" class="user-menu-item">
            <div class="user-menu__logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4.99988 21.87C4.25988 21.87 3.52988 21.59 2.96988 21.03C2.42988 20.49 2.12988 19.77 2.12988 19C2.12988 18.23 2.42988 17.51 2.96988 16.97L15.9699 3.97C17.0899 2.85 18.9099 2.85 20.0299 3.97C20.5699 4.51 20.8699 5.23 20.8699 6C20.8699 6.77 20.5699 7.49 20.0299 8.03L7.02988 21.03C6.46988 21.59 5.73988 21.87 4.99988 21.87ZM17.9999 4.63001C17.6499 4.63001 17.2999 4.76001 17.0299 5.03001L4.02988 18.03C3.76988 18.29 3.62988 18.63 3.62988 19C3.62988 19.37 3.76988 19.71 4.02988 19.97C4.55988 20.5 5.43988 20.5 5.96988 19.97L18.9699 6.97C19.2299 6.71 19.3699 6.37 19.3699 6C19.3699 5.63 19.2299 5.29001 18.9699 5.03001C18.6999 4.76001 18.3499 4.63001 17.9999 4.63001Z"
                  fill="#848FAC"
                />
                <path
                  d="M18.01 9.73999C17.82 9.73999 17.63 9.66999 17.48 9.51999L14.48 6.51999C14.19 6.22999 14.19 5.74999 14.48 5.45999C14.77 5.16999 15.25 5.16999 15.54 5.45999L18.54 8.45999C18.83 8.74999 18.83 9.22999 18.54 9.51999C18.39 9.66999 18.2 9.73999 18.01 9.73999Z"
                  fill="#848FAC"
                />
                <path
                  d="M10.0001 5.50001C9.95005 5.50001 9.91005 5.49001 9.86005 5.48001L8.50005 5.08001L7.14005 5.48001C6.96005 5.53001 6.77005 5.48001 6.65005 5.35001C6.52005 5.22001 6.47005 5.04001 6.52005 4.86001L6.92005 3.50001L6.52005 2.14001C6.47005 1.96001 6.52005 1.77001 6.65005 1.65001C6.78005 1.52001 6.97005 1.47001 7.14005 1.52001L8.50005 1.92001L9.86005 1.52001C10.0401 1.47001 10.2201 1.52001 10.3501 1.65001C10.4801 1.78001 10.5301 1.97001 10.4801 2.14001L10.0801 3.50001L10.4801 4.86001C10.5301 5.04001 10.4801 5.23001 10.3501 5.35001C10.2601 5.45001 10.1301 5.50001 10.0001 5.50001ZM8.50005 4.06001C8.55005 4.06001 8.59005 4.07001 8.64005 4.08001L9.26005 4.26001L9.08005 3.64001C9.05005 3.55001 9.05005 3.45001 9.08005 3.36001L9.26005 2.74001L8.64005 2.92001C8.55005 2.95001 8.45005 2.95001 8.36005 2.92001L7.74005 2.74001L7.92005 3.36001C7.95005 3.45001 7.95005 3.55001 7.92005 3.64001L7.74005 4.26001L8.36005 4.08001C8.41005 4.07001 8.45005 4.06001 8.50005 4.06001Z"
                  fill="#848FAC"
                />
                <path
                  d="M6.00005 11.5C5.95005 11.5 5.91005 11.49 5.86005 11.48L4.50005 11.08L3.14005 11.48C2.96005 11.53 2.78005 11.48 2.65005 11.35C2.52005 11.22 2.47005 11.03 2.52005 10.86L2.92005 9.50001L2.52005 8.14001C2.47005 7.96001 2.52005 7.77001 2.65005 7.65001C2.78005 7.53001 2.97005 7.47001 3.14005 7.52001L4.50005 7.92001L5.86005 7.52001C6.03005 7.47001 6.22005 7.52001 6.35005 7.65001C6.48005 7.78001 6.53005 7.97001 6.48005 8.14001L6.08005 9.50001L6.48005 10.86C6.53005 11.04 6.48005 11.23 6.35005 11.35C6.26005 11.45 6.13005 11.5 6.00005 11.5ZM4.50005 10.06C4.55005 10.06 4.59005 10.07 4.64005 10.08L5.26005 10.26L5.08005 9.64001C5.05005 9.55001 5.05005 9.45001 5.08005 9.36001L5.26005 8.74001L4.64005 8.92001C4.55005 8.95001 4.45005 8.95001 4.36005 8.92001L3.74005 8.74001L3.92005 9.36001C3.95005 9.45001 3.95005 9.55001 3.92005 9.64001L3.74005 10.26L4.36005 10.08C4.41005 10.07 4.45005 10.06 4.50005 10.06Z"
                  fill="#848FAC"
                />
                <path
                  d="M21.0001 16.5C20.9501 16.5 20.9101 16.49 20.8601 16.48L19.5001 16.08L18.1401 16.48C17.9601 16.53 17.7801 16.48 17.6501 16.35C17.5201 16.22 17.4701 16.03 17.5201 15.86L17.9201 14.5L17.5201 13.14C17.4701 12.96 17.5201 12.77 17.6501 12.65C17.7801 12.53 17.9701 12.47 18.1401 12.52L19.5001 12.92L20.8601 12.52C21.0301 12.47 21.2201 12.52 21.3501 12.65C21.4801 12.78 21.5301 12.97 21.4801 13.14L21.0801 14.5L21.4801 15.86C21.5301 16.04 21.4801 16.23 21.3501 16.35C21.2601 16.45 21.1301 16.5 21.0001 16.5ZM19.5001 15.06C19.5501 15.06 19.5901 15.07 19.6401 15.08L20.2601 15.26L20.0801 14.64C20.0501 14.55 20.0501 14.45 20.0801 14.36L20.2601 13.74L19.6401 13.92C19.5501 13.95 19.4501 13.95 19.3601 13.92L18.7401 13.74L18.9201 14.36C18.9501 14.45 18.9501 14.55 18.9201 14.64L18.7401 15.26L19.3601 15.08C19.4101 15.07 19.4501 15.06 19.5001 15.06Z"
                  fill="#848FAC"
                />
              </svg>
            </div>
            <span>{{ $t("navigation.user.pricing") }}</span>
          </router-link>
        </li> -->
        <li class="">
          <div class="user-menu-item" @click="signOut">
            <img
              src="@/assets/images/login.svg"
              class="user-menu__logo"
              alt="logout"
            />
            <span>{{ $t("navigation.user.signout") }}</span>
          </div>
        </li>
        <!-- <li class="border-t border-greyscale-400">
          <div class="mt-2 pt-3 flex justify-between tooltip-target b3">
            <div class="text-sm text-secondary-900">Dark Mode</div>
            <v-popover>
              <div @click="isChecked = !isChecked" class="flex items-center cursor-pointer">
                <div class="relative">
                  <input
                    type="checkbox"
                    id="toggle121"
                    class="sr-only"
                    v-model="isChecked"
                  />
                  <div
                    class="toggle__line"
                    :class="{
                      'bg-checkbox-blue': isChecked,
                      'bg-greyscale-200': !isChecked,
                    }"
                  >
                    <div
                      class="toggle__dot"
                      :class="{
                        'right-0.5': isChecked,
                        'left-0.5': !isChecked,
                      }"
                    ></div>
                  </div>
                </div>
              </div>
              <template slot="popover">
                <div class="flex gap-2 items-center">
                  <img
                    class="w-4 h-4"
                    src="@/assets/images/coming-soon.svg"
                    alt=""
                  />
                  <p>Coming soon...</p>
                </div>
              </template>
            </v-popover>
          </div>
        </li> -->
      </ul>
    </div>
    <Modal
      v-if="showOrCloseContactSales"
      @close="showOrCloseContactSales = $event"
      :title="$t('navigation.user.subscriptiondetails')"
    >
      <template v-slot:header>
        <div>
          <h3 class="text-white">
            {{ $t("navigation.user.subscriptiondetails") }}
          </h3>
        </div>
      </template>
      <template v-slot:body>
        <div
          class="flex flex-col m-6 border-solid border-[1px] border-greyscale-500 rounded"
        >
          <div
            class="flex justify-between w-full border-b-[1px] border-greyscale-500"
          >
            <span class="w-full p-3 border-r border-greyscale-500">
              {{ $t("modal.plan_code") }}
            </span>
            <span class="w-full p-3">{{
              userPlanDetail.recurringPaymentCode
            }}</span>
          </div>
          <div
            class="flex justify-between w-full border-b-[1px] border-greyscale-500"
          >
            <span class="w-full p-3 border-r border-greyscale-500">{{
              $t("modal.plan_name")
            }}</span>
            <span class="w-full p-3">{{
              userPlanDetail.recurringPlan.title
            }}</span>
          </div>
          <div
            class="flex justify-between w-full border-b-[1px] border-greyscale-500"
          >
            <span class="w-full p-3 border-r border-greyscale-500">{{
              $t("modal.recurring_start_date")
            }}</span>
            <span class="w-full p-3">{{
              userPlanDetail.recurringPaymentStartDate | moment("DD/MM/YYYY")
            }}</span>
          </div>
          <div class="flex justify-between w-full">
            <span class="w-full p-3 border-r border-greyscale-500">{{
              $t("modal.recurring_end_date")
            }}</span>
            <span class="w-full p-3">{{
              userPlanDetail.recurringPaymentExpireDate | moment("DD/MM/YYYY")
            }}</span>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="w-full flex justify-end pr-6 gap-4 mt-4">
          <button
            :class="[
              cancelButtonStyles,
              'bg-alerts-warning-500 flex items-center justify-center cursor-pointer',
            ]"
            @click="getNavigateCardUpdateLink"
            :disabled="!userPlanDetail.isCancellable"
          >
            Kart Güncelle
          </button>
          <button
            :class="cancelButtonStyles"
            @click="openConfirmationPopup(userPlanDetail.isCancellable)"
            :disabled="!userPlanDetail.isCancellable"
          >
            {{ $t("button.general.cancel_subscription") }}
          </button>
        </div>
      </template>
    </Modal>
    <Modal
      v-if="isConfirmationPopup"
      @close="isConfirmationPopup = $event"
      :title="$t('navigation.user.subscriptiondetails')"
      isWarningPopup
    >
      <template v-slot:header>
        <div>
          <h3 class="text-white">{{ $t("modal.cancel_modal_title") }}</h3>
        </div>
      </template>
      <template v-slot:body>
        <div class="p-8">
          {{ $t("notification.modal.popup_desc") }}
        </div>
      </template>
      <template v-slot:footer>
        <div class="flex w-full justify-center gap-4">
          <Button
            class="!h-[48px] !min-w-40 border-rdc-gray text-black border-[1px] font-regular"
            @click="openConfirmationPopup(closePopup)"
          >
            {{ $t("button.general.cancel") }}
          </Button>
          <Button
            @click="cancelRecurringPlanMethod"
            class="!h-[48px] !min-w-40 px-8 text-sm font-bold rounded-md bg-rdc-red border border-rdc-gray text-primary-white"
            >{{ $t("button.general.confirm") }}</Button
          >
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
const Modal = () => import("@/components/Modal");
import Button from "@/components/Button";

const navigateBaseUrl = process.env.VUE_APP_PAYMENT_LINK;
export default {
  name: "HeaderUser",
  components: {
    Modal,
    Button,
  },
  data() {
    return {
      userMenu: false,
      isChecked: false,
      userPlanDetail: "",
      showOrCloseContactSales: false,
      isConfirmationPopup: false,
    };
  },
  methods: {
    ...mapActions([
      "logout",
      "emitMixPanelEvent",
      "cancelRecurringPlan",
      "emitNotification",
      "initAuth",
    ]),
    toggleDisplayMenu() {
      if (this.isLaunchDevicePage) return;
      this.userMenu = !this.userMenu;
    },
    closePopup() {
      this.userMenu = false;
    },
    signOut() {
      this.logout();
    },
    getNavigateCardUpdateLink() {
      const token = localStorage.getItem("access_token");
      const url = `${navigateBaseUrl}/cardUpdate?&token=${token}`;
      window.open(url, "_blank");
    },
    showOrCloseContactSalesMethod() {
      this.closePopup();
      this.showOrCloseContactSales = !this.showOrCloseContactSales;
    },
    openConfirmationPopup(value) {
      if (value) {
        this.showOrCloseContactSales = false;
        this.isConfirmationPopup = !this.isConfirmationPopup;
      }
      if (value == "closePopup") {
        this.isConfirmationPopup = false;
      }
    },
    async cancelRecurringPlanMethod() {
      if (this.userPlanDetail.recurringPaymentCode) {
        await this.cancelRecurringPlan(this.userPlanDetail.recurringPaymentCode)
          .then(() => {
            this.emitNotification({
              type: "success",
              text: this.$t("modal.cancel_modal_success_text"),
            });
            this.isConfirmationPopup = false;
            this.initAuth();
          })
          .catch(() => {
            this.emitNotification({
              type: "error",
              text: this.$t("modal.cancel_modal_error_text"),
            });
          });
      }
    },
  },
  computed: {
    ...mapGetters(["joinedUser", "session"]),
    initials() {
      if (this.joinedUser) {
        const names = this.joinedUser.fullName.split(" ");
        if (names.length === 1) {
          return names[0].charAt(0).toUpperCase();
        }
        const firstInitial = names[0].charAt(0).toUpperCase();
        const secondInitial = names[1].charAt(0).toUpperCase();
        return firstInitial + secondInitial;
      } else {
        if (!this.guestName) return;
        const names = this.guestName.split(" ");
        if (names.length === 1) {
          return names[0].charAt(0).toUpperCase();
        }
        const firstInitial = names[0].charAt(0).toUpperCase();
        const secondInitial = names[1].charAt(0).toUpperCase();
        return firstInitial + secondInitial;
      }
    },
    guestName() {
      return this.session?.name;
    },
    isLaunchDevicePage() {
      return (
        this.$route.name === "DeviceLauncherAndroid" ||
        this.$route.name === "DeviceLauncherIos"
      );
    },
    cancelButtonStyles() {
      return this.userPlanDetail.isCancellable
        ? "!h-[48px] max-w-32 px-8 text-sm font-bold rounded-md bg-rdc-red border border-rdc-gray text-primary-white"
        : "!h-[48px] max-w-32 px-8 text-sm rounded-md bg-rdc-gray text-primary-white cursor-not-allowed";
    },
  },
  watch: {
    isChecked(value) {
      this.$emit("toggle", value);
    },
    joinedUser: {
      handler(plan) {
        if (plan) {
          this.userPlanDetail = plan.client;
        }
      },
      immediate: true,
    },
  },
};
</script>
<style>
@import "index.module.css";
</style>
